import VueRouter from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('./components/HelloWorld.vue'),
  },
  {
    path: '/presentacion',
    name: 'PresentacionComercial',
    component: () => import('./views/PresentacionComercial.vue'),
    meta: { fullscreen: true, title: 'APS Pensiones — Presentación Comercial' }
  },
  {
    path: '/institucional',
    name: 'PresentacionInstitucional',
    component: () => import('./views/PresentacionInstitucional.vue'),
    meta: { fullscreen: true, title: 'APS Pensiones — Presentación Institucional' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0, behavior: 'smooth' }
  }
});

export default router;
